import React from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";

const propTypes = {
  floated: PropTypes.oneOf(["left", "right"]),
  action: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  color: PropTypes.string
};

const defaultProps = {
  buttonText: "Guardar Cambios",
  floated: "left",
  disabled: false,
  icon: null,
  color: "pink"
};

function BotonGuardar(props) {
  return (
    <Button
      basic={props.basic}
      icon={props.icon}
      color={props.color}
      floated={props.floated}
      content={props.buttonText}
      onClick={props.action}
      disabled={props.disabled}
    />
  );
}

BotonGuardar.defaultProps = defaultProps;

BotonGuardar.propTypes = propTypes;

export default BotonGuardar;



// WEBPACK FOOTER //
// ./src/pages/shared/botones/BotonGuardar.jsx